// extracted by mini-css-extract-plugin
export default {"root":"Rating_root__1djqS","star":"Rating_star__Bjf3q","candidate":"Rating_candidate__em82p"};